import { useFormStore } from "@/widgets/classic-form/form";
import type { Fields } from "@/widgets/classic-form/form";
import { useOtherFieldsWithExactnessDisabled } from "../shared/useOtherFieldsWithExactnessDisabled";

const otherFieldsAreExact = (otherFields: Fields, disabled: Set<string>) =>
    Object.entries(otherFields).every(([key, field]) => disabled.has(key) || field.isExact);

export const useOtherFieldsAreExact = () => {
    const fieldsWithExactnessDisabled = useOtherFieldsWithExactnessDisabled();

    const isExact = useFormStore((data) => otherFieldsAreExact(data.values.fields, fieldsWithExactnessDisabled));

    return isExact;
};
